"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _typography = require("@vds-core/typography");
var _propTypes = _interopRequireDefault(require("prop-types"));
var propTypes = {
  size: _propTypes["default"].oneOf(["XSmall", "small", "medium", "large", "XLarge", "2XLarge"])
};
var defaultProps = {
  size: "small",
  viewport: "desktop"
};
var Title = function Title(props) {
  var _calculateLineHeight = function _calculateLineHeight() {
    var isMobile = props.viewport === "mobile";
    switch (props.size) {
      case "2XLarge":
        return isMobile ? "36px" : "64px";
      case "XLarge":
        return isMobile ? "32px" : "48px";
      case "large":
        return isMobile ? "24px" : "32px";
      case "medium":
        return isMobile ? "20px" : "24px";
      case "XSmall":
        return "16px";
      case "small":
        return isMobile ? "16px" : "20px";
      default:
        return null;
    }
  };
  var _calculateFontSize = function _calculateFontSize() {
    var isMobile = props.viewport === "mobile";
    switch (props.size) {
      case "2XLarge":
        return isMobile ? "36px" : "64px";
      case "XSmall":
        return "14px";
      default:
        return null;
    }
  };
  var _calculateLetterSpacing = function _calculateLetterSpacing() {
    if (props.viewport === "desktop" && props.size === "2XLarge") return "0px";
    return null;
  };
  return /*#__PURE__*/_react["default"].createElement(_typography.Title, (0, _extends2["default"])({}, props, {
    bold: true,
    fontSize: _calculateFontSize(),
    lineHeight: _calculateLineHeight(),
    letterSpacing: _calculateLetterSpacing()
  }));
};
Title.defaultProps = defaultProps;
Title.propTypes = propTypes;
var _default = exports["default"] = Title;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/typography/dist/cjs/components/Title/Title.js
// module id = 1634
// module chunks = 0